import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Percentage = forwardRef<SVGSVGElement | null, IconFilledProps>(function Percentage({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          d='M16.273 7.8586C16.4455 7.64297 16.4106 7.32832 16.1949 7.15582L15.8045 6.84347C15.5889 6.67097 15.2742 6.70593 15.1017 6.92156L7.72641 16.1407C7.55391 16.3563 7.58887 16.671 7.8045 16.8435L8.19493 17.1558C8.41056 17.3283 8.72521 17.2934 8.89771 17.0777L16.273 7.8586Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.75 8.99987C6.75 7.75723 7.75736 6.74987 9 6.74987C10.2426 6.74987 11.25 7.75723 11.25 8.99987C11.25 10.2425 10.2426 11.2499 9 11.2499C7.75736 11.2499 6.75 10.2425 6.75 8.99987ZM9 8.24987C8.58579 8.24987 8.25 8.58566 8.25 8.99987C8.25 9.41409 8.58579 9.74987 9 9.74987C9.41421 9.74987 9.75 9.41409 9.75 8.99987C9.75 8.58566 9.41421 8.24987 9 8.24987Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.75 14.9999C12.75 13.7572 13.7574 12.7499 15 12.7499C16.2426 12.7499 17.25 13.7572 17.25 14.9999C17.25 16.2425 16.2426 17.2499 15 17.2499C13.7574 17.2499 12.75 16.2425 12.75 14.9999ZM15 14.2499C14.5858 14.2499 14.25 14.5857 14.25 14.9999C14.25 15.4141 14.5858 15.7499 15 15.7499C15.4142 15.7499 15.75 15.4141 15.75 14.9999C15.75 14.5857 15.4142 14.2499 15 14.2499Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          d='M9 8.24987C8.58579 8.24987 8.25 8.58566 8.25 8.99987C8.25 9.41409 8.58579 9.74987 9 9.74987C9.41421 9.74987 9.75 9.41409 9.75 8.99987C9.75 8.58566 9.41421 8.24987 9 8.24987Z'
          fill={filled ? color : 'transparent'}
        />
        <path
          d='M14.25 14.9999C14.25 14.5857 14.5858 14.2499 15 14.2499C15.4142 14.2499 15.75 14.5857 15.75 14.9999C15.75 15.4141 15.4142 15.7499 15 15.7499C14.5858 15.7499 14.25 15.4141 14.25 14.9999Z'
          fill={filled ? color : 'transparent'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.273 7.8586C16.4455 7.64297 16.4106 7.32832 16.1949 7.15582L15.8045 6.84347C15.5889 6.67097 15.2742 6.70593 15.1017 6.92156L7.72641 16.1407C7.55391 16.3563 7.58887 16.671 7.8045 16.8435L8.19493 17.1558C8.41056 17.3283 8.72521 17.2934 8.89771 17.0777L16.273 7.8586ZM6.75 8.99987C6.75 7.75723 7.75736 6.74987 9 6.74987C10.2426 6.74987 11.25 7.75723 11.25 8.99987C11.25 10.2425 10.2426 11.2499 9 11.2499C7.75736 11.2499 6.75 10.2425 6.75 8.99987ZM15 12.7499C13.7574 12.7499 12.75 13.7572 12.75 14.9999C12.75 16.2425 13.7574 17.2499 15 17.2499C16.2426 17.2499 17.25 16.2425 17.25 14.9999C17.25 13.7572 16.2426 12.7499 15 12.7499Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'percentage-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Percentage;
